export default function uploadFile(data) {
    this.processFileInput({multiple: false, way: data.way}, (file) => {
        this.deleteFile(data);

        this.uploadCacheFile(file, (files) => {
            this.canDownload = false;
            const file = files.ids[0];
            this.saveField({
                way: data.way,
                name: data.name,
                type: 'file',
                value: file,
            });
        });
    });
}
